import {
  EXPIRE_KEY,
  getStorageItem,
  setStorageItem,
  removeStorageItem
} from './LocalStorage'

import axios from 'axios'

// 配置文件
import Config from '@/config'

import App from '@/main'

/**
 * 格式化日期
 * @param {*} string 日期字符串
 * @returns 返回格式为 2019-01-01 的字符串
 */
let formatDate = string => {
  let dateObj = new Date(string)

  let year = dateObj.getFullYear()
  let month = dateObj.getMonth() + 1
  let date = dateObj.getDate()

  month = month > 9 ? month : `0${month}`
  date = date > 9 ? date : `0${date}`

  return `${year}-${month}-${date}`
}

// 获取 token 方法
let getToken = (callback) => {
  axios.get(process.env.VUE_APP_API, {
    params: {
      appid: Config.appid,
      secret: Config.secret,
      type: 'get_access_token'
    }
  })
    .then(resp => {
      let data = resp.data

      if (resp.status === 200 && data.CODE === 'OK') {
        callback(data.TOKEN_INFO.ACCESS_TOKEN) // 回调方法，返回 token

        // 设置 token
        setExpire(data.TOKEN_INFO.EXP)
      } else {
        // iview 显示 API 请求错误
        showMsg({
          type: 'error',
          content: formatErrorMsg(data.ERROR_CODE, data.MSG)
        })
      }
    })
    .catch(err => {
      showMsg({
        type: 'error',
        content: err
      })
    })
}

/**
 * 显示错误信息
 * iview UI 使用全局提示 $Message
 * @param {Object}
 *    type 是全局提示类型，取值 info success warning error loading
 *    content 提示内容
 */
let showMsg = ({
  type,
  content
} = params) => {
  switch (type) {
    case 'info':
      App.$Message.info({
        content
      })
      break
    case 'success':
      App.$Message.success({
        content
      })
      break
    case 'warning':
      App.$Message.warning({
        content
      })
      break
    case 'error':
      App.$Message.error({
        content
      })
      break
    case 'loading':
      App.$Message.loading({
        content
      })
      break
  }
}

/**
 * 设置 token 过期时间，使用 localStorage
 * @param {String} timestamp 过期时间戳
 */
let setExpire = (timestamp) => {
  let expireTime = parseInt(timestamp, 10) * 1000 // 过期时间戳，毫秒

  if (getStorageItem(EXPIRE_KEY)) {
    expireTime < Date.now() ? removeStorageItem(EXPIRE_KEY) : '' // 过期则删除
  } else { // 不存在则设置
    setStorageItem(EXPIRE_KEY, expireTime)
  }
}

/**
 * 格式化请求 API 失败的错误信息
 * @param {String} code 错误码
 * @param {String} msg 错误信息
 * @returns {String} 返回格式化后的信息
 */
let formatErrorMsg = (code, msg) => {
  return `${code} - ${msg}`
}

export {
  formatDate,
  getToken,
  showMsg
}
